import {Box, Typography} from "@mui/material";
import {c} from "../landingTokens";
import {Section, Eyebrow, SectionHeading, Dim} from "./Shell";

const PROBLEMS = [
  {title: "Overwhelmed agents", body: "High call volumes lead to burnout, attrition and costly training cycles."},
  {title: "Frustrated customers", body: "Long hold times and repetitive queries damage satisfaction and loyalty."},
  {title: "Skyrocketing costs", body: "Labor expenses eat into profits, but scaling teams isn't sustainable."},
];

export const ProblemStatement = () => (
  <Section label="Problem" sx={{pt: {xs: 8, md: 14.75}, borderTop: `1px solid rgba(44,43,42,0.1)`}}>
    <Eyebrow>The problem</Eyebrow>
    <SectionHeading sx={{mb: 7, maxWidth: 860}}>
      Is your contact center<br />
      <Dim>drowning in calls?</Dim>
    </SectionHeading>

    <Box sx={{display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))", gap: 2.5}}>
      {PROBLEMS.map((p) => (
        <Box
          key={p.title}
          sx={{
            background: `linear-gradient(165deg, #F3F5FE, ${c.white})`,
            border: `1px solid ${c.line}`,
            borderRadius: "24px",
            p: {xs: 3.5, md: 4},
          }}
        >
          <Box sx={{width: 40, height: 40, borderRadius: "12px", bgcolor: "rgba(132,145,247,0.18)", mb: 2.5}} />
          <Typography sx={{fontSize: 22, letterSpacing: "-0.02em", fontWeight: 600, mb: 1.25}}>{p.title}</Typography>
          <Typography sx={{fontSize: 15, lineHeight: 1.55, color: c.inkSoft}}>{p.body}</Typography>
        </Box>
      ))}
    </Box>
  </Section>
);
